const crawlerPatterns = [
  // Google crawlers
  { name: 'Googlebot', pattern: /Googlebot/i, category: 'search-engine' },
  { name: 'Google-Extended', pattern: /Google-Extended/i, category: 'ai-crawler' },
  { name: 'Google-InspectionTool', pattern: /Google-InspectionTool/i, category: 'search-engine' },
  { name: 'Googlebot-Image', pattern: /Googlebot-Image/i, category: 'search-engine' },
  { name: 'Googlebot-Video', pattern: /Googlebot-Video/i, category: 'search-engine' },
  { name: 'AdsBot-Google', pattern: /AdsBot-Google/i, category: 'ads' },
  
  // AI/LLM crawlers
  { name: 'GPTBot', pattern: /GPTBot/i, category: 'ai-crawler' },
  { name: 'ChatGPT-User', pattern: /ChatGPT-User/i, category: 'ai-crawler' },
  { name: 'CCBot', pattern: /CCBot/i, category: 'ai-crawler' },
  { name: 'anthropic-ai', pattern: /anthropic-ai/i, category: 'ai-crawler' },
  { name: 'Claude-Web', pattern: /Claude-Web/i, category: 'ai-crawler' },
  
  // Other search engines
  { name: 'Bingbot', pattern: /bingbot/i, category: 'search-engine' },
  { name: 'Slurp', pattern: /Slurp/i, category: 'search-engine' },
  { name: 'DuckDuckBot', pattern: /DuckDuckBot/i, category: 'search-engine' },
  { name: 'Baiduspider', pattern: /Baiduspider/i, category: 'search-engine' },
  { name: 'YandexBot', pattern: /YandexBot/i, category: 'search-engine' },
  
  // Social media
  { name: 'facebookexternalhit', pattern: /facebookexternalhit/i, category: 'social-media' },
  { name: 'LinkedInBot', pattern: /LinkedInBot/i, category: 'social-media' },
  { name: 'WhatsApp', pattern: /WhatsApp/i, category: 'social-media' },
  { name: 'Twitterbot', pattern: /Twitterbot/i, category: 'social-media' },
  { name: 'Slackbot', pattern: /Slackbot/i, category: 'social-media' },
  
  // SEO tools
  { name: 'AhrefsBot', pattern: /AhrefsBot/i, category: 'seo-tool' },
  { name: 'SemrushBot', pattern: /SemrushBot/i, category: 'seo-tool' },
  { name: 'MJ12bot', pattern: /MJ12bot/i, category: 'seo-tool' },
  { name: 'DotBot', pattern: /DotBot/i, category: 'seo-tool' },
  { name: 'Screaming Frog', pattern: /Screaming Frog/i, category: 'seo-tool' },
  
  // Others
  { name: 'Amazonbot', pattern: /Amazonbot/i, category: 'e-commerce' },
  { name: 'Applebot', pattern: /Applebot/i, category: 'search-engine' },
  { name: 'PetalBot', pattern: /PetalBot/i, category: 'search-engine' },
];

export const detectCrawler = (userAgent) => {
  if (!userAgent) return null;
  
  for (const crawler of crawlerPatterns) {
    if (crawler.pattern.test(userAgent)) {
      return {
        detected: true,
        name: crawler.name,
        category: crawler.category,
        userAgent: userAgent
      };
    }
  }
  
  return {
    detected: false,
    name: null,
    category: null,
    userAgent: userAgent
  };
};

export const getCrawlerInfo = () => {
  const userAgent = navigator.userAgent;
  const crawlerInfo = detectCrawler(userAgent);
  
  return {
    ...crawlerInfo,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    referrer: document.referrer || 'direct',
    language: navigator.language,
    platform: navigator.platform,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
  };
};

export const isCrawler = () => {
  const userAgent = navigator.userAgent;
  const result = detectCrawler(userAgent);
  return result.detected;
};